<!-- 职位申请 -->
<template>    
    <div v-loading="loading" :style="{'min-height':minHeight}" style="background-color: rgba(0,0,0,0.05);color:#292c32;width:100%;display: flex;flex-direction: column;align-items: center;justify-content: flex-start;">
        <div v-if="personList.length>0" style="margin:30px 0;width:1200px;box-sizing: border-box;padding: 20px 20px;background-color: #ffffff;display: flex;flex-direction: column;align-items: center;justify-content: center;">
            <div style="font-size:13px;color:#515a5e;display: flex;justify-content: space-between;align-items: center;height: 60px;line-height: 60px;width:100%;">
                <div style="display: flex;justify-content:flex-start;align-items: center;height: 100%;line-height: 100%;">
                    <img src="../../static/other/people.png" style="width:32px;height: 32px;">
                    <div style="margin-left:10px;font-weight: bolder;">{{personList[0].name}}</div>
                </div>
                <div style="display: flex;justify-content: flex-start;align-items: center;height: 100%;line-height: 100%;">
                    <img src="../../static/other/email2.png" style="width:32px;height: 32px;">
                    <div style="margin-left:10px;font-weight: bolder;">{{email}}</div>
                </div>
            </div>
            <el-collapse v-model="activeNames" @change="handleChange" style="width:100%;">
                <el-collapse-item name="1">
                    <template slot="title">
                        <img src="../../static/other/shezhi.png" style="width:24px;height: 24px;margin-right: 10px;">
                        <div style="font-weight: bolder;">账号信息</div>
                    </template>
                    <div style="padding: 0 20px;">
                        <el-form :inline="true" :model="personList[0]" label-width="60px" class="demo-form-inline">
                            <el-form-item label="邮箱">
                                <el-input disabled v-model="personList[0].email"></el-input>
                            </el-form-item>
                            <el-form-item label="姓名">
                                <el-input disabled v-model="personList[0].name"></el-input>
                            </el-form-item>
                            <el-form-item  label="身份证">
                                <el-input disabled v-model="personList[0].IDCard"></el-input>
                            </el-form-item>

                            <el-form-item style="height:35px;margin-left:20px;">
                                <el-button style="color:#fff;height:35px;border-radius: 5px;background-color: #c40001;font-size:13px;border-color: #c40001;" type="primary" @click="resetPassword">重置密码</el-button>
                            </el-form-item>
                        </el-form>
                </div>
                </el-collapse-item>
                <el-collapse-item  name="2" style="position: relative;">
                    <div @click="save" style="position: absolute;top: 0;right:40px;cursor: pointer;margin:10px 0;padding: 6px 20px;border-radius: 5px;background-color: #c40001;color:#fff;font-size:13px;">
                        保存简历
                    </div>
                    <!-- <el-button :loading="saveDisabled" :disabled="saveDisabled" @click="save" style="position: absolute;top: 0;right:40px;cursor: pointer;margin:10px 0;width:90px;height:35px;border-radius: 5px;background-color: #c40001;color:#fff;font-size:13px;">保存简历</el-button> -->
                    <template slot="title">
                        <img src="../../static/other/jianli1.png" style="width:24px;height: 24px;margin-right: 10px;">
                        <div style="font-weight: bolder;">个人简历</div>
                    </template>

                    <div style="width:100%;color:#575d6a;font-size:14px;" >
                        <table border="1"  cellspacing="0" cellpadding="0"  style="border-style: none;border-color:#dddddd;text-align: center; width: 100%; border-collapse: collapse;">
                            <tr style="height: 50px;width:100%;">
                                <td style="width:130px;">姓名
                                    <span v-if="mustInput.name==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>
                                </td>
                                <td style="width:160px;">
                                    <el-input maxlength="10"
                                  placeholder="请输入姓名" style="width:90%;"  v-model="personList[0].name"  clearable>
                                    </el-input>             
                                    
                                </td>
                                <td style="width:320px;">出生年月
                                    <span v-if="mustInput.birthday==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>                                   
                                </td>
                                <td style="width:170px;">
                                    <el-date-picker
                                        style="width:90%;"
                                        v-model="personList[0].birthday"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </td>
                                <td style="width:100px;">性别
                                    <span v-if="mustInput.sex==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td style="width:160px;">
                                    <el-select v-model="personList[0].sex" style="width:90%;" clearable>
                                        <el-option label="男" value="男"></el-option>
                                        <el-option label="女" value="女"></el-option>
                                    </el-select>
                                </td>
                                <td rowspan="3" style="width:140px;">
                                    <el-upload
                                        class="avatar-uploader"
                                        :action="handlerUrl"
                                        :data="uploadAvatarData"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload"
                                        accept=".png,.jpg,.gif,.jpeg">                                       
                                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </td>
                            </tr>
                            <tr style="height: 50px;width:100%;">
                                <td>入党时间
                                    <span v-if="mustInput.partyTime==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-date-picker
                                        style="width:90%;"
                                        v-model="personList[0].partyTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="选择入日期">
                                    </el-date-picker>
                                </td>
                                <td>身高(cm)
                                    <span v-if="mustInput.height==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-input oninput="value=value.replace(/[^0-9.]/g,'')"  style="width:90%;"  v-model="personList[0].height"  clearable>
                                    </el-input>
                                </td>
                                <td>民族
                                    <span v-if="mustInput.nation==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-input maxlength="10"  style="width:90%;"  v-model="personList[0].nation"  clearable>
                                    </el-input>
                                </td>                   
                            </tr>
                            <tr style="height: 50px;width:100%;">
                                <td>特长
                                    <span v-if="mustInput.speciality==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td colspan="2">
                                    <el-input  maxlength="200" style="width:90%;"  v-model="personList[0].speciality"  clearable>
                                    </el-input>
                                </td>
                                <td>电话
                                    <span v-if="mustInput.phoneNumber==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td colspan="2">
                                    <el-input oninput="value=value.replace(/[^\d]/g,'')" maxlength="11"   style="width:90%;"  v-model="personList[0].phoneNumber"  clearable>
                                    </el-input>
                                </td>                         
                            </tr>
                            <tr style="height: 50px;width:100%;">
                                <td rowspan="4">个人学历</td>
                                <td></td>
                                <td>起止时间</td>
                                <td colspan="2">就读学校</td>
                                <td>所学专业</td>  
                                <td>担任学生干部情况</td>                         
                            </tr>
                            <tr style="height: 50px;width:100%;">                      
                                <td>本科
                                    <span v-if="mustInput.bachelor==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-date-picker
                                        style="width:140px"
                                        v-model="personList[0].bachelorStartTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="开始日期">
                                    </el-date-picker>
                                    至
                                    <el-date-picker
                                        style="width:140px;"
                                        v-model="personList[0].bachelorEndTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="截止日期">
                                    </el-date-picker>

                                </td>
                                <td colspan="2">
                                    <el-input  maxlength="20" style="width:90%;"  v-model="personList[0].bachelorSchool"  clearable>
                                    </el-input>
                                </td>
                                <td>
                                    <el-input maxlength="20"  style="width:90%;"  v-model="personList[0].bachelorMajor"  clearable>
                                    </el-input>
                                </td>  
                                <td>
                                    <el-input maxlength="50"  style="width:90%;"  v-model="personList[0].bachelorOther"  clearable>
                                    </el-input>
                                </td>                         
                            </tr>
                            <tr style="height: 50px;width:100%;">                      
                                <td>硕士
                                    <span v-if="mustInput.master==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-date-picker
                                        style="width:140px;"
                                        v-model="personList[0].masterStartTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="开始日期">
                                    </el-date-picker>
                                    至
                                    <el-date-picker
                                        style="width:140px;"
                                        v-model="personList[0].masterEndTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="截止日期">
                                    </el-date-picker>
                                </td>
                                <td colspan="2">
                                    <el-input maxlength="20"  style="width:90%;"  v-model="personList[0].masterSchool"  clearable>
                                    </el-input>
                                </td>
                                <td>
                                    <el-input  maxlength="20" style="width:90%;"  v-model="personList[0].masterMajor"  clearable>
                                    </el-input>
                                </td>  
                                <td>
                                    <el-input maxlength="50"  style="width:90%;"  v-model="personList[0].masterOther"  clearable>
                                    </el-input>
                                </td>                         
                            </tr>
                            <tr style="height: 50px;width:100%;">                       
                                <td>博士
                                    <span v-if="mustInput.doctor==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td>
                                    <el-date-picker
                                        style="width:140px;"
                                        v-model="personList[0].doctorStartTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="开始日期">
                                    </el-date-picker>
                                    至
                                    <el-date-picker
                                        style="width:140px;"
                                        v-model="personList[0].doctorEndTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd">
                                        placeholder="截止日期">
                                    </el-date-picker>
                                </td>
                                <td colspan="2">
                                    <el-input  maxlength="20" style="width:90%;"  v-model="personList[0].doctorSchool"  clearable>
                                    </el-input>
                                </td>
                                <td>
                                    <el-input  maxlength="20" style="width:90%;"  v-model="personList[0].doctorMajor"  clearable>
                                    </el-input>
                                </td>  
                                <td>
                                    <el-input  maxlength="50" style="width:90%;"  v-model="personList[0].doctorOther"  clearable>
                                    </el-input>
                                </td>                         
                            </tr>
                            <tr style="width:100%;">                       
                                <td>工作经历
                                    <span v-if="mustInput.experience==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>
                                    <span style="display:inline-block;color:#ff0000;font-size:12px">(请按时间倒序,先录入最近的工作经历)</span>
                                </td>
                                <td colspan="6">
                                    <div style="width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;">

                                        <div v-for="item in experienceList" style="padding:20px 0;width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;position: relative;"> 
                                            <div style="width:99%;display: flex;align-items: center;justify-content: flex-start;">
                                                
                                                <el-date-picker                                                                                                     
                                                    style="width:140px;margin:0 10px 0 0;"
                                                    v-model="item.startDate"
                                                    type="date"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd">
                                                    placeholder="开始日期">
                                                </el-date-picker>
                                                至
                                                <el-date-picker
                                                    style="width:140px;margin:0 10px 0 10px;"
                                                    v-model="item.endDate"
                                                    type="date"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd">
                                                    placeholder="截止日期">
                                                </el-date-picker>
                                                
                                                <el-input placeholder=""  
                                                style="width:300px;margin-right:10px;"  
                                                v-model="item.company"    
                                                maxlength="50"                                           
                                                >
                                                <template slot="prepend">所在单位</template>
                                                </el-input>
                                                
                                                <el-input placeholder=""   
                                                style="width:300px;"  
                                                v-model="item.duty"
                                                maxlength="50"  
                                                >
                                                <template slot="prepend">担任职务</template>
                                                </el-input>
                                            </div>
                                            <div style="margin-top: 10px;width:99%;">
                                                <el-input
                                                    style="width:100%;"
                                                    type="textarea"
                                                    :autosize="{ minRows: 5}"
                                                    placeholder="请输入工作概述"
                                                    v-model="item.describe"
                                                    maxlength="500"
                                                    show-word-limit>
                                                >
                                                </el-input>
                                            </div>
                                            <div @click="removeWorkExperience(item.id)" style="position:absolute;color:#c40001;font-size: 12px;top:0px;right:20px;padding: 5px 10px;font-weight: bolder;cursor: pointer;;">删除</div>
                                        </div>

                                        <div class="el-icon-circle-plus-outline" @click="addWorkExperience" style="cursor: pointer;margin:10px 0;padding: 6px 20px;border-radius: 5px;background-color: #fff;color:#c40001;border:1px solid #c40001;font-size:12px;">
                                                添加
                                        </div>

                                    </div>
                                </td>
                            </tr>

                            <tr style="width:100%;">                       
                                <td>应聘子集
                                    <span v-if="mustInput.result==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>
                                    <!-- <span style="display:inline-block;color:#ff0000;font-size:12px">(请按时间倒序,先录入最近一次的应聘子集)</span> -->
                                </td>                                
                                <td colspan="6">
                                    <div style="width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;">

                                        <div v-for="item in resultList" style="padding:20px 0;width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;position: relative;"> 
                                            <div style="margin-top: 10px;width:99%;display: flex;">
                                                <div style="width:10%;color:#bcbcbc;padding:0 10px;box-sizing: border-box;">{{resultName.rewardName}}</div>

                                                <el-input                                               
                                                    style="width:90%;"
                                                    type="textarea"
                                                    :autosize="{ minRows: 5}"
                                                    placeholder=""
                                                    v-model="item.reward"
                                                    maxlength="300"
                                                    show-word-limit>
                                                </el-input>
                                            </div>
                                            <div style="margin-top: 10px;width:99%;display: flex;">
                                                <div style="width:10%;color:#bcbcbc;padding:0 10px;box-sizing: border-box;">{{resultName.gainName}}</div>

                                                <el-input
                                                    style="width:90%;"
                                                    type="textarea"
                                                    :autosize="{ minRows: 5}"
                                                    placeholder=""
                                                    v-model="item.gain"
                                                    maxlength="300"
                                                    show-word-limit>
                                                </el-input>
                                            </div>
                                            <div style="margin-top: 10px;width:99%;display: flex;">
                                                <div style="width:10%;color:#bcbcbc;padding:0 10px;box-sizing: border-box;">{{resultName.activityName}}</div>
                                                <el-input
                                                    style="width:90%;"
                                                    type="textarea"
                                                    :autosize="{ minRows: 5}"
                                                    placeholder=""
                                                    v-model="item.activity"
                                                    maxlength="300"
                                                    show-word-limit>
                                                </el-input>
                                            </div>
                                            <div @click="removeResult(item.id)" style="position:absolute;color:#c40001;font-size: 12px;top:0px;right:20px;padding: 5px 10px;font-weight: bolder;cursor: pointer;;">删除</div>

                                        </div>

                                        <div v-if="this.resultList.length==0" class="el-icon-circle-plus-outline" @click="addResult" style="cursor: pointer;margin:10px 0;padding: 6px 20px;border-radius: 5px;background-color: #fff;color:#c40001;border:1px solid #c40001;font-size:12px;">
                                                添加
                                        </div>
                                    </div>
                                </td>
                            </tr>


                            <tr style="width:100%;">                       
                                <td>家庭主要成员
                                    <span v-if="mustInput.family==1" style="display:inline-block;color:#ff0000;transform: translateY(2px);">*</span>

                                </td>
                                <td colspan="6">
                                    <div style="width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                                        <div v-for="item in familyList" style="padding:20px 0;width:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;position: relative;"> 
                                            <div style="width:99%;display: flex;align-items: center;justify-content: flex-start;">
                                                <el-input maxlength="10"   placeholder="" v-model="item.call" style="width:140px;margin-right:10px;" >
                                                    <template slot="prepend">称谓</template>
                                                </el-input>
                                                <el-input maxlength="10"  placeholder="" v-model="item.name" style="width:160px;margin-right:10px;" >
                                                    <template slot="prepend">姓名</template>
                                                </el-input>
                                                <el-input oninput="value=value.replace(/[^\d]/g,'')" placeholder="" v-model="item.age" style="width:130px;margin-right:10px;" >
                                                    <template slot="prepend">年龄</template>
                                                </el-input>
                                                <el-input maxlength="10" placeholder="" v-model="item.police" style="width:170px;margin-right:10px;" >
                                                    <template slot="prepend">政治面貌</template>
                                                </el-input>
                                                <el-input maxlength="50"  placeholder="" v-model="item.other" style="width:320px;" >
                                                    <template slot="prepend">工作单位及职位</template>
                                                </el-input>
                                            </div>
                                            <div @click="removeFamily(item.id)" style="position:absolute;color:#c40001;font-size: 12px;top:0px;right:20px;padding: 5px 10px;font-weight: bolder;cursor: pointer;;">删除</div>
                                        </div>

                                        <div class="el-icon-circle-plus-outline" @click="addFamily" style="cursor: pointer;margin:10px 0;padding: 6px 20px;border-radius: 5px;background-color: #fff;color:#c40001;border:1px solid #c40001;font-size:12px;">
                                                添加
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>                    
                    </div>
                </el-collapse-item>
                <el-collapse-item  name="3">
                    <template slot="title">
                        <img src="../../static/other/yunduanshangchuan.png" style="width:24px;height: 24px;margin-right: 10px;">
                        <div style="font-weight: bolder;">上传附件</div>
                    </template>     
                    <div style="width:100%;">                    
                        <el-upload                                       
                            class="upload-demo"  
                            ref="upload"    
                            list-type="text"                                                                       
                            :action="handlerUrl"   
                            :data="uploadExperData"                          
                            :on-remove="handleExperRemove"
                            :before-remove="beforeExperRemove"
                            :on-change="onExperChange"
                            :on-preview="onExperPreview"
                            :limit="1"
                            :on-exceed="handleExperExceed"
                            :file-list="experFilesList"
                            accept=".doc,.docx,.pdf"
                            :on-success="upExperSuccess"
                            :on-error="upExperError"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary" >选择文件</el-button>
                            <el-button style="margin-left: 10px;background-color: #409eff;font-size:12px" size="small" type="success" @click="submitExperUpload">上传报名登记表</el-button>
                            <span style="margin-left:20px;color:#ff6600;font-size:12px;">附件上传步骤：① 前往招聘首页-招聘公告里面下载对应岗位报名登记附件 ② 点击选择文件 ③ 点击上传报名登记表</span>
                            <div  style="color:#ff6600;font-size:12px;" slot="tip" class="el-upload__tip">支持pdf、doc、docx文件格式；附件大小不得超过1M；</div>
                        </el-upload>
                    </div>
                    <div style="width:100%;margin-top: 30px;">
                        <el-upload                                       
                            class="upload-demo"  
                            ref="uploadOther"   
                            list-type="text"                                                  
                            :action="handlerUrl"            
                            :on-remove="handleOtherRemove"
                            :before-remove="beforeOtherRemove"                            
                            :on-change="onOtherChange"
                            :on-preview="onOtherPreview"
                            :limit="100"
                            :multiple="true"
                            :on-exceed="handleOtherExceed"
                            :file-list="otherFilesList"
                            accept=".png,.jpg,.jpeg"
                            :on-success="upOtherSuccess"
                            :on-error="upOtherError"
                            :auto-upload="false">
                            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
                            <el-button style="margin-left: 10px;background-color: #4091ff;font-size:12px" size="small" type="success" :loading="uploadOtherDisabled" :disabled="uploadOtherDisabled"  @click="submitOtherUpload">上传其他附件</el-button>
                            <span style="margin-left:20px;color:#ff6600;font-size:12px">附件上传步骤：① 点击选择文件 ② 点击上传其他附件</span>

                            <div  style="color:#ff6600;font-size:12px;" slot="tip" class="el-upload__tip">身份证、学历/学位证、获奖证书、科研成果等扫描件；只支持png、jpg、jpeg文件格式;文件总大小不得超过50M；</div>
                        </el-upload>
                    </div>
                </el-collapse-item>
                <el-collapse-item  name="4">
                    <template slot="title">
                        <img src="../../static/other/zuzhiqunzu.png" style="width:24px;height: 24px;margin-right: 10px;">
                        <div style="font-weight: bolder;">已投岗位</div>
                    </template>
                    <div style="padding: 0 20px;">
                    <el-empty v-if="jobApplyList.length==0" description="还未申请任何岗位"></el-empty>
                    <el-table v-else
                        :header-cell-style="{'text-align':'center','color':'#515a61','font-size':'12px'}"
                        :cell-style="{'text-align':'center','font-size':'13px','color':'#888888'}"
                        :data="jobApplyList"
                        stripe
                        style="width: 100%">
                        <el-table-column
                        prop="jobTitle"
                        label="岗位"
                        >
                        </el-table-column>
                        
                        <el-table-column
                        prop="childDeptName"
                        label="岗位名称"
                        >
                        </el-table-column>

                        <el-table-column
                        prop="deptTypeName"
                        label="院系类别"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="deptName"
                        label="部门名称"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="applyTime"
                        label="应聘时间"                      
                        >
                        </el-table-column>
                    </el-table>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
 export default {
     name:'JobEdit',
     data () {
         return {
            loading:true,
            userName:'',
            email:'',
            input:'',
            value1: [],
            options:[],
            textarea2:'',
            value:[],
            imageUrl: '',
            activeNames: ['1','2','3','4'],    
            // 
            personList:[],
            experienceList:[],
            resultList:[],
            familyList:[],
            jobApplyList:[],

            minHeight:'100%',
            //附件相关
            experFilesList:[],
            otherFilesList:[],            
            uploadExperData:{},
            uploadOtherData:{}, 
            handlerUrl:'',
            uploadOtherDisabled:false,
                    // 
            //必填项
            mustInput:{},
            //岗位id
            jobId:'',
            rerultName:{},
        }
     },
     methods:{
        //上传简历附件相关方法------------------
        handleExperRemove(file, fileList) {
            console.log('删除');
            if (file.id != undefined && file.id.length>0){
                var param={id:file.id};
                this.$axios.post(
                    this.Global.globalUrl+'/interface/uploadFilesRemove.ashx',
                    JSON.stringify(param),
                    {
                        header: { 'content-type': 'application/x-www-form-urlencoded' }
                    })
                .then((res) => {
                    if (res.data.err==0){
                        this.$message.success('删除成功');                        
                    }else{
                        this.$message.error('删除失败');                        
                    }
                })
                .catch(() => {
                })

            }
        },
        submitExperUpload() {
            this.$refs.upload.submit();
        },
        handleExperExceed(files, fileList) {
            this.$message.error(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeExperRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        onExperChange(file, fileList) {
            this.experFilesList = fileList
            const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
            const whiteList = ['pdf', 'doc', 'docx']
            const isSuffix = whiteList.indexOf(fileSuffix.toLowerCase()) === -1
            const isLt1M = file.size / 1024 / 1024 > 1

            const legalUlr = this.checkFileName(file.name)//判断文件名是否合法
            if (isSuffix) {
                this.$message.error('上传文件只能是 pdf、doc、docx格式')
                const currIdx = this.experFilesList.indexOf(file)
                this.experFilesList.splice(currIdx, 1)
                return
            }
            if (isLt1M) {
                this.$message.error('上传文件大小不能超过 1MB')
                const currIdx = this.experFilesList.indexOf(file)
                this.experFilesList.splice(currIdx, 1)
                return
            }

            if (!legalUlr){ 
                this.$message.error('文件名不能包含特殊字符')
                const currIdx = this.experFilesList.indexOf(file)
                this.experFilesList.splice(currIdx, 1)
                return

            }
        },
         // 上传成功function(response, file, fileList)
        upExperSuccess(response, file, fileList) {
            this.$message.success('已成功上传到服务器')
           // this.experFilesList = response.fileList;
           if (response.errMsg.length==0){
                file.id=response.fileObj[0].id;
                file.url=response.fileObj[0].url;
           }      
      
        },
        // 上传失败
        upExperError(e) {
            this.$message.error('上传失败', 'error')
        },
        onExperPreview(file){
            if (file.url != undefined && file.url.length>0){
            window.open(decodeURIComponent(file.url));
            }

        },
        //上传其他附件相关方法------------------------
        handleOtherRemove(file, fileList) {
            var that=this;
            console.log('删除');
            if (file.id != undefined && file.id.length>0){
                var param={id:file.id};
                this.$axios.post(
                    this.Global.globalUrl+'/interface/uploadFilesRemove.ashx',
                    JSON.stringify(param),
                    {
                        header: { 'content-type': 'application/x-www-form-urlencoded' }
                    })
                .then((res) => {
                    if (res.data.err==0){
                        const currIdx = that.otherFilesList.indexOf(file);
                        that.otherFilesList.splice(currIdx, 1);
                        console.log(that.otherFilesList);
                        this.$message.success('删除成功');                        
                    }else{
                        this.$message.error('删除失败');                        
                    }
                })
                .catch(() => {
                })

            }else{
                const currIdx = this.otherFilesList.indexOf(file);
                this.otherFilesList.splice(currIdx, 1);
            }
            console.log('删除otherfilelist:'+this.otherFilesList);
        },
        submitOtherUpload() {
            //this.$refs.uploadOther.submit();
            //自定义上传方法
            var that=this;
            that.uploadOtherDisabled=true;
            //是否有同名文件
            // var size = new Set(that.otherFilesList.map(item=>item.name)).size;
            // if (size != that.otherFilesList.length){
            //     this.$message.error('上传附件中含有同名文件');
            //     return;

            // }
            let formData = new FormData();
            formData.append('objectType', '1');
            formData.append('type', '2');
            formData.append('objectId', this.getSessionStorage('id'));
            formData.append('uid', this.getSessionStorage('id'));
          
            let i=0;
            this.otherFilesList.forEach(file => {
                if (file.id ==undefined || file.id.length==0){
                    i=i+1;
                    formData.append('files', file.raw);
                }
            });
            if (i==0){
                this.$message.error('没有要上传的附件');
                that.uploadOtherDisabled=false;
                return;
            }
            console.log('formdata:'+formData);
            this.$axios.post(
                    this.Global.globalUrl+'/interface/uploadFiles.ashx',
                    formData,
                    {
                        header: { 'Content-Type': 'multipart/form-data'}
                    })
                .then((res) => {
                    if (res.data.errMsg.length==0){   
                    //删除id为空的                    

                    var fileList = that.otherFilesList;
                    var fileList1=[];
                    fileList.forEach(item => {
                        if (item.id != undefined && item.id.length>0){                            
                            fileList1.push(item);
                        }
 
                    });
                    
                    that.otherFilesList=fileList1.concat(res.data.fileObj);
                    this.$message.success('已成功上传至服务器')

                    }else{
                        this.$message.error('上传失败:'+res.data.errMsg)
               
                    }
                })
                .catch(() => {
                })
                .finally(()=>{
                     // 处理上传成功后的逻辑
                    setTimeout(() => {
                        that.uploadOtherDisabled=false; // 将按钮恢复为可用
                    }, 1000); // 延迟 1 秒                  
                    
                })

        },
        handleOtherExceed(files, fileList) {
            this.$message.error(`当前限制最多选择 100 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        //文件删除前的钩子函数
        beforeOtherRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        //初始化的时候将otherFileList赋值给fileList 此时otherFileList为已上传的文件，都带id的；
        //当change的时候，此时fileList为列表显示的所有附件包含带id(已经上传成功的文件)的和不带id的(刚刚选择的文件)
        //当提交上传时，仅仅过滤不带id的，后台保存成功后将返回刚才过滤出的文件并加上id
        //这样就不会重复提交列表的文件，但是要控制按钮，防止连续点击，可以通过beforeUpload 方法中来控制按钮是否可以点击
        onOtherChange(file, fileList) {
            //在赋值前先判断是否含重名文件
            // if(this.checkRepeate(file)){
            //     this.$message.error('上传文件不能同名')
            //     const currIdx = fileList.indexOf(file)
            //     fileList.splice(currIdx, 1)

            //     return
            // }
            
            this.otherFilesList = fileList
            let totalSize = 0;
            for(let i=0;i<fileList.length;i++){
                totalSize+=fileList[i].size;
            }

            const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
            const whiteList = ['png', 'jpg','jpeg']
            const isSuffix = whiteList.indexOf(fileSuffix.toLowerCase()) === -1
            const isLt10M = totalSize / 1024 / 1024 > 50//总大小不超过50M
            const legalUlr = this.checkFileName(file.name)//判断文件名是否合法：1不能包含空格
       
            if (isSuffix) {
                this.$message.error('上传文件只能是png、jpg、jpeg格式')
                const currIdx = this.otherFilesList.indexOf(file)
                this.otherFilesList.splice(currIdx, 1)
                return
            }
            if (isLt10M) {
                this.$message.error('上传文件总大小不能超过 50MB')
                const currIdx = this.otherFilesList.indexOf(file)
                this.otherFilesList.splice(currIdx, 1)
                return
            }

            if (!legalUlr){ 
                this.$message.error('文件名中含有非法字符')
                const currIdx = this.otherFilesList.indexOf(file)
                this.otherFilesList.splice(currIdx, 1)
                return

            }
            //判断是否有重复
            const lowercaseItems = fileList.map(item => item.name.toLowerCase());
            var size = new Set(lowercaseItems).size;
            console.log('Set(lowercaseItems).size:'+size );
            console.log('fileList.length:'+fileList.length);
            if (size !== fileList.length){
                this.$message.error('已有相同文件')
                const currIdx = this.otherFilesList.indexOf(file)
                this.otherFilesList.splice(currIdx, 1)
                return
            }


            console.log('filelist:'+fileList);
            // this.otherFileList=fileList;
        },
        //判断是否重名
        checkRepeate(file){

            for(let i=0;i<this.otherFilesList.length;i++){
                var filesName = this.otherFilesList[i].name;
                if (filesName==file.name){
                    
                    return true;
                }
            }
            return false;
        },
        upOtherSuccess(response, file, fileList) {
            //this.uploadOtherDisabled=false;
            this.$message.success('已成功上传到服务器')
            console.log('上传其他附件成功');
            // if (response.err=='0'){
                // file.id=response.fileObj.id;
                // file.url=response.fileObj.url;
            // }
        },

        // 上传失败
        upOtherError(e) {
            //this.uploadOtherDisabled=false;
            this.$message.error('上传失败', 'error')
        },
        onOtherPreview(file){
            if (file.url != undefined && file.url.length>0){

            window.open(decodeURIComponent(file.url));
            }

        },

        //上传图像相关方法-----------------------------
        handleAvatarSuccess(res, file) {
            this.imageUrl = URL.createObjectURL(file.raw);
            //console.log('头像上传err：'+res.err);
            // if (res.err=='0'){                            
            //     this.imageUrl = URL.createObjectURL(file.raw)
            //     console.log('头像上传imageUrl：'+this.imageUrl );
            // }            
        },
        beforeAvatarUpload(file) {
            const isJPG =
            file.type === 'image/jpeg' ||
            file.type === 'image/png' ||
            file.type === 'image/jpg';
            
            const isLt1M = file.size / 1024 / 1024 < 1;
            const legalUlr = this.checkFileName(file.name)//判断文件名是否合法

            if (!isJPG) {
            this.$message.error('上传头像图片只能是 jpg、png、jpeg格式!');
            }
            if (!isLt1M) {
            this.$message.error('上传头像图片大小不能超过 1MB!');
            }
            if (!legalUlr){
            this.$message.error('文件名不能包含特殊字符!');
            }
            return isJPG && isLt1M && legalUlr;      
        },
        handleChange(val) {
            console.log(val);
        },


        addWorkExperience(){
            var item={id:this.guid(),startTime:'',endTime:'',company:'',duty:'',describe:'',orderIndex:0,personId:''};
            this.experienceList.push(item);
        },
        removeWorkExperience(itemId){    
            var index = this.experienceList.findIndex(item=>item.id==itemId);
            if (index != -1){
                this.experienceList.splice(index,1);
            }
        },
        addResult(){
            var item={id:this.guid(),reward:'',activity:'',gain:'',orderIndex:0,personId:''};
            this.resultList.push(item);
        },
        removeResult(itemId){
            var index = this.resultList.findIndex(item=>item.id==itemId);
            if (index != -1){
                this.resultList.splice(index,1);
            }

        },
        // 校验文件名是否合法
        checkFileName(fileName) {
            const reg = /[\\^$*+?()|[\]{}]/  
            if (reg.test(fileName)) {
                console.log('文件名中含有非法字符!');
                return false;
            }
            return true;      
        },

        addFamily(){
            var item={id:this.guid(),call:'',age:'',name:'',police:'',other:'',orderIndex:0,personId:''};
            this.familyList.push(item);
        },
        removeFamily(itemId){
           
            var index = this.familyList.findIndex(item=>item.id==itemId)
            if (index != -1){
                this.familyList.splice(index,1);
            }

        },

        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        getDataList(){
            var that=this;
            var id = this.getSessionStorage('id');
            this.$axios.get(this.Global.globalUrl+'/interface/getPersonApply.ashx'
            ,{params:{id:id,jobId:this.jobId}})
            .then((res) => {
                that.personList = res.data.personList;
                that.familyList=res.data.familyList;
                that.resultList=res.data.resultList;
                that.experienceList=res.data.experienceList; 
                that.jobApplyList=res.data.jobApplyList;
                that.experFilesList=res.data.experFilesList;
                that.otherFilesList=res.data.otherFilesList; 
                if (res.data.avatarFilesList.length>0){
                    that.imageUrl = decodeURIComponent(res.data.avatarFilesList[0].url);  
                } 
                that.mustInput=res.data.mustInput;
                that.resultName=res.data.resultName;
            })
            .catch(() => {
            })
            .finally(()=>{
                this.loading=false;
            })

        },
        saveCheck(){
            // if (this.personList[0].name==null || this.personList[0].name.length==0){
            //     this.$message.error('请输入姓名');
            //     return false;
            // }
            // if (this.personList[0].birthday==null || this.personList[0].birthday.length==0){
            //     this.$message.error('请输入出生年月');
            //     return false;
            // }
            // if (this.personList[0].nation==null || this.personList[0].nation.length==0){
            //     this.$message.error('请输入民族');
            //     return false;
            // }
            // if (this.personList[0].phoneNumber==null || this.personList[0].phoneNumber.length==0){
            //     this.$message.error('请输入电话');
            //     return false;
            // }
            // if (this.personList[0].height==null || this.personList[0].height.length==0){
            //     this.$message.error('请输入身高');
            //     return false;
            // }
            // if (this.personList[0].speciality==null || this.personList[0].speciality.length==0){
            //     this.$message.error('请输入特长');
            //     return false;
            // }
            if (this.imageUrl.length==0){
                this.$message.error('请输上传头像');
                return false;
            }

            return true;
        },
        save(){
            var that=this;
            this.loading=true;
            //服务端验证
            if (!this.saveCheck()){
                this.loading=false;
                return;
            }
            var id=this.getSessionStorage('id');
            if (id==undefined || id.length==0){
                that.loading=false;
                //路由到登录页面
                this.$router.push({name:'Login'});
                return;
            }
            //保存简历 调用API
            var arr = [];
            var jsont = { "id": id,"jobId":this.jobId, "personList": this.personList,'resultList':this.resultList,'familyList':this.familyList,'experienceList':this.experienceList};
            arr.push(jsont);

            this.$axios.post(
                this.Global.globalUrl+'/interface/savePersonApply.ashx',
                JSON.stringify(arr),
                {
                    header: { 'content-type': 'application/x-www-form-urlencoded' }
                })
            .then((res) => {               
                if (res.data.err==0){
                    this.$message({
                        duration:3000,                   
                        type: 'success',
                        message: '保存成功!'
                    });
                }else{
                    this.$message({
                        duration:5000,                      
                        type: 'error',
                        message: res.data.errMsg
                    });
                }
            })
            .catch(() => {
            })
            .finally(()=>{
                setTimeout(() => {
                    that.loading=false;
                }, 1000);                
            })

        },
        resetPassword(){
            this.$router.push({name:'ResetPassword'});
        },

     },
     created(){
        this.userName=this.getSessionStorage('name');
        this.email=this.getSessionStorage('email');
        this.jobId = this.getLocalStorage('jobId');
        console.log('jobId:'+this.jobId);
        this.getDataList();       

     },
     mounted(){
        this.$nextTick(function () {
            this.minHeight = (document.documentElement.clientHeight -200)+'px';
            this.uploadExperData = {objectType:'1',type:'1',objectId:this.getSessionStorage('id'),uid:this.getSessionStorage('id')};
            this.uploadOtherData = {objectType:'1',type:'2',objectId:this.getSessionStorage('id'),uid:this.getSessionStorage('id')};
            this.uploadAvatarData = {objectType:'1',type:'3',objectId:this.getSessionStorage('id'),uid:this.getSessionStorage('id')};

            this.handlerUrl = this.Global.globalUrl+'/interface/uploadFiles.ashx';

        })

        this.$router.onReady(() => {            
                // this.jobId=this.$route.query.jobId;                
                // console.log('jobId:'+this.$route.query.jobId);                
                // console.log('jobId:'+this.jobId);
                // this.getDataList();        
            })

    }
 }
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 133px;
    height: 145px;
    line-height: 145px;
    text-align: center;
  }
  .avatar {
    width: 133px;
    height: 145px;
    display: block;
  }
  .el-icon-plus:before {
    content: "上传照片 *";
    font-size: 12px;
    color:rgb(255,0,0);
  }

  .el-input--suffix .el-input__inner{
    padding-right: 20px;
  }
</style>
